import type { PromptCategory } from "@1js/pl-types";
import {
  ArrowSyncCheckmarkRegular,
  ArrowTrendingLinesRegular,
  CatchUpRegular,
  ChatBubblesQuestionRegular,
  DesignIdeasRegular,
  DraftsRegular,
  EditRegular,
  LightbulbRegular,
  PersonNoteRegular,
  SignatureRegular,
  TextBulletListSquareRegular,
  WrenchScrewdriverRegular,
} from "@fluentui/react-icons";
import React from "react";
import type { Appearance } from "../../data";
import { useStyles } from "./PromptIcon.styles";

export type PromptIconProps = {
  displayCategory: PromptCategory;
  appearance?: Appearance;
  isUserPrompt?: boolean;
};

export const displayCategoryToIcon = (
  displayCategory: PromptCategory,
  styles: Record<"icon", string>
) => {
  switch (displayCategory) {
    case "Create":
    case "Suggestion":
    case "Brainstorm":
      return <DraftsRegular className={styles.icon} />;
    case "Email":
      return <CatchUpRegular className={styles.icon} />;
    case "Edit":
      return <EditRegular className={styles.icon} />;
    case "Catch up":
    case "Summarize":
      return <TextBulletListSquareRegular className={styles.icon} />;
    case "Ask":
      return <ChatBubblesQuestionRegular className={styles.icon} />;
    case "Understand":
      return <LightbulbRegular className={styles.icon} />;
    case "UserAuthored":
    case "Created by Me":
      return <SignatureRegular className={styles.icon} />;
    case "Customize":
      return <PersonNoteRegular className={styles.icon} />;
    case "Design":
      return <DesignIdeasRegular className={styles.icon} />;
    case "Optimize":
      return <ArrowTrendingLinesRegular className={styles.icon} />;
    case "Operate":
      return <ArrowSyncCheckmarkRegular className={styles.icon} />;
    case "Troubleshoot":
      return <WrenchScrewdriverRegular className={styles.icon} />;
    default:
      return <></>;
  }
};

export const PromptIcon: React.FC<PromptIconProps> = ({
  displayCategory,
  appearance,
  isUserPrompt,
}) => {
  const styles = useStyles(appearance)();
  const displayCategoryToUse = isUserPrompt ? "Created by Me" : displayCategory;
  return (
    <span data-testid="prompt-icon">
      {displayCategoryToIcon(displayCategoryToUse, styles)}
    </span>
  );
};
